const defaultTooltip = () => 
`
  <Tooltip
    target={<ActionIcon icon="information" type="40" />}
  >
    <Layout>
      <Row>
        <Title>Title</Title>
      </Row>
      <Row>
        <Description>
          Description Text Here Two lines
        </Description>
      </Row>
      <Row>
        <Label>
          Label
        </Label>
        <ListElement>
          list element
        </ListElement>
      </Row>
      <Row>
        <Label>
          Label
        </Label>
        <ListElement>
          list element
        </ListElement>
      </Row>
    </Layout>
  </Tooltip>
`;

const withIconTooltip = () => 
`
  <Tooltip
    target={<ActionIcon icon="information" type="40" />}
  >
    <Layout>
      <Row>
        <Title>Title</Title>
      </Row>
      <Row>
        <Description>
          Description Text Here
        </Description>
      </Row>
    </Layout>
  </Tooltip>
`;

const withFlagTooltip = () => 
`
  <Tooltip
    target={<ActionIcon icon="information" type="40" />}
  >
    <Layout>
      <Row>
        <Title>Title</Title>
      </Row>
      <Row>
        <Description>
          Description Text Here
        </Description>
      </Row>
    </Layout>
  </Tooltip>
`;

const tooltipTemplates = {
  default: defaultTooltip(),
  withIcon: withIconTooltip(),
  withFlag: withFlagTooltip()
};

export default tooltipTemplates;


// WEBPACK FOOTER //
// ./src/containers/elements/Tooltips/constants/tooltipTemplates.js